import React, { useState, useEffect, useContext } from 'react';
import 'react-app-polyfill/ie11';
import { BsCloudUpload } from "react-icons/bs";
import { IoChevronBackCircle } from "react-icons/io5";
import Moment from 'react-moment';

import AuthContext from 'store/AuthContext';
import uploadedFilesSservice from '../../services/uploadedFiles.service';
import AppButton from 'components/FormsUI/AppButton/appButton';
import AppPagination from "components/common/AppPagination";
import AppSkeleton from 'components/common/skeleton/AppSkeleton';
import { AppTableNoData } from 'components/common/AppTableUtils';

import '../common/tables.css';
import '../Flights/FlightList.css';

const UploadedFilesList = (props) => {
    const { userInfo } = useContext(AuthContext);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });
    const { location: { state: { airlineCode = null } = {} } } = props

    const fetchData = async () => {
        const list = await uploadedFilesSservice.getFiles(!!airlineCode ? airlineCode : userInfo.airlineCode);
        const sortedFiles = list.sort((a, b) => b.uploadDate.localeCompare(a.uploadDate));
        setData(sortedFiles);
        setIsLoading(false);
    }

    useEffect(() => {
        setIsLoading(true);
        fetchData();
    }, [])

    const backhandler = () => {
        props.history.goBack();
    }
    const redirectToUploadFile = () => {
        props.history.push({
            pathname: `/UploadFile`
        })
    }

    if (data === undefined) {
        return (null);
    }

    return (<>
        <div className="container">
            <div className="row mb-3">
                <div className="col-md-7">
                    <h2>Uploaded files for Airline {!!airlineCode ? airlineCode : userInfo.airlineCode} - {userInfo.airline ? userInfo.airline.airline : null}
                    </h2>
                </div>
                <div className="col-md-5">
                    {!userInfo.isOwner && 
                        <AppButton id="addFlightBtn" color="warning" action={redirectToUploadFile} label="Upload File" classes="rightBtn" icon={<BsCloudUpload />} ></AppButton>
                    }
                </div>
            </div>
            {isLoading ? <AppSkeleton rows={paginationObject.pageSize} cols={8} variant="table" size="25px"/> : 
            <React.Fragment>

                <table className="table table-hover table-sm table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">File Name</th>
                            <th scope="col">File Type</th>
                            <th scope="col">File Origin</th>
                            <th scope="col">Load Status</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">First Name</th>
                            <th scope="col">Server User</th>
                            <th scope="col">Upload Date Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                            return (
                                <tr key={item.id}>
                                    <td className="col">{item.fileName}</td>
                                    <td className="col">{item.fileType === "C" ? (<span>CSV</span>) : item.fileType === "T" ? (<span>TXT</span>) : item.fileType}</td>
                                    <td className="col">{item.fileOrigin === "P" ? (<span>Portal</span>) : item.fileOrigin === "S" ? (<span>Server</span>) : item.fileOrigin}</td>
                                    <td className="col">{item.loadStatus === 1 ? (<span>OK</span>) :
                                        item.loadStatus === 2 ? (<span>ERROR</span>) :
                                            (<span>NA</span>)} </td>
                                    <td className="col">{item.lastName}</td>
                                    <td className="col">{item.firstName}</td>
                                    <td className="col">{item.serverUser}</td>
                                    <td className="col"><Moment format="DD MMM yy H:mm A">{item.uploadDate}</Moment></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                {!data.length ? <AppTableNoData /> : 
                    <AppPagination
                        pageSize={paginationObject.pageSize}
                        totalRecords={data.length}
                        currentPage={paginationObject.currPage}
                        endIndex={paginationObject.endIndex}
                        startIndex={paginationObject.startIndex}
                        setPaginationObject={(ele) => {
                            setPaginationObject((data) => {
                                return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                            })
                        }}
                    ></AppPagination>
                }
            </React.Fragment>
            }
            <div className="row">
                <div className="col-md-12">
                    <AppButton classes="mt-4" action={backhandler} label="Back" icon={<IoChevronBackCircle />}></AppButton>
                </div>
            </div>
        </div>
    </>

    )
}
export default UploadedFilesList;

